"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHSJ = void 0;
var react_1 = __importStar(require("react"));
var quotetable_1 = require("../quotetable");
var hotlinks_1 = require("../quotetable/hotlinks");
var morezb_1 = require("../quotetable/morezb");
require("./hsj.less");
var maintab_1 = require("./shared/maintab");
var react_router_dom_1 = require("react-router-dom");
var crumbs_1 = require("../crumbs");
var url_1 = require("../../modules/url");
/**
 * 自定义指标
 */
var custom_quote = [
    { title: '市净率', value: '市净率', sort: true, sort_alias: "PB" },
    { title: '总市值', value: '总市值', sort: true, sort_alias: "MarketValue" },
    { title: '流通市值', value: '流通市值', sort: true, sort_alias: "FlowCapitalValue" },
    { title: '60日涨跌幅', value: '涨跌幅_60日', sort: true, sort_alias: "ChangePercent60Day" },
    { title: '年初至今涨跌幅', value: '年初至今涨跌幅', sort: true, sort_alias: "ChangePercent360Day" },
    { title: '涨速', value: '涨速_3分钟', sort: true, sort_alias: "Speed" },
    { title: '5分钟涨跌', value: '涨跌幅_5分钟', sort: true, sort_alias: "FiveMinuteChangePercent" }
];
/**
 * 沪深京页面
 * @returns
 */
function PageHSJ() {
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash;
    var _a = (0, react_1.useState)(custom_quote[0]), showzb = _a[0], SetShowZB = _a[1]; //选择的指标
    var _b = (0, react_1.useState)(0), onIndex = _b[0], setOnIndex = _b[1];
    var _c = (0, react_1.useState)(false), mounted = _c[0], setMoundted = _c[1];
    (0, react_1.useEffect)(function () {
        var url_sort_name = (0, url_1.getQueryParams)("st");
        if (url_sort_name) {
            var index = custom_quote.findIndex(function (v) { var _a; return ((_a = v.sort_alias) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == url_sort_name.toLowerCase(); });
            console.info(index);
            var current_index = index > -1 ? index : 0;
            setOnIndex(current_index);
            SetShowZB(custom_quote[index]);
        }
        setMoundted(true);
    }, []);
    var changeSelectIndex = function (index) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                setOnIndex(index);
                SetShowZB(custom_quote[index]);
                return [2 /*return*/];
            });
        });
    };
    if (!mounted)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: "pagehsj" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefresh, null),
        react_1.default.createElement(maintab_1.MainTab2, null),
        (hash != '#staq_net_board') &&
            react_1.default.createElement("div", { className: "hlmzb scf" },
                react_1.default.createElement("div", { className: "hl" },
                    hash == '#hs_a_board' &&
                        react_1.default.createElement(hotlinks_1.HSJHotLinks, null),
                    (hash == '#sh_a_board' || hash == '#sh_a_board_zcz' || hash == '#sh_a_board_hzz') &&
                        react_1.default.createElement("div", { className: "tab3hot" },
                            react_1.default.createElement(maintab_1.MainTab3, null),
                            react_1.default.createElement(hotlinks_1.SHHotLinks, null)),
                    (hash == '#sz_a_board' || hash == '#sz_a_board_zcz' || hash == '#sz_a_board_hzz') &&
                        react_1.default.createElement("div", { className: "tab3hot" },
                            react_1.default.createElement(maintab_1.MainTab3, null),
                            react_1.default.createElement(hotlinks_1.SZHotLinks, null)),
                    hash == '#newshares' &&
                        react_1.default.createElement(hotlinks_1.NewStockHotLinks, null),
                    (hash == '#gem_board' || hash == '#gem_board_zcz' || hash == '#gem_board_hzz') &&
                        react_1.default.createElement("div", { className: "tab3hot" },
                            react_1.default.createElement(maintab_1.MainTab3, null)),
                    hash == '#kcb_board' &&
                        react_1.default.createElement(hotlinks_1.KCBHotLinks, null),
                    hash == '#sh_hk_board' &&
                        react_1.default.createElement(hotlinks_1.SH_HKHotLinks, null),
                    hash == '#sz_hk_board' &&
                        react_1.default.createElement(hotlinks_1.SZ_HKHotLinks, null),
                    hash == '#b_board' &&
                        react_1.default.createElement(hotlinks_1.BStockHotLinks, null),
                    (hash == '#ab_comparison' || hash == '#ab_comparison_sh' || hash == '#ab_comparison_sz') &&
                        react_1.default.createElement("div", { className: "tab3hot" },
                            react_1.default.createElement(maintab_1.MainTab3, null)),
                    (hash == '#st_board' || hash == '#st_board_sh' || hash == '#st_board_sz' || hash == '#st_board_bj' || hash == '#st_board_kcb' || hash == '#st_board_cyb') &&
                        react_1.default.createElement("div", { className: "tab3hot" },
                            react_1.default.createElement(maintab_1.MainTab3, null)),
                    (hash == '#delisting_board' || hash == '#delisting_board_sh' || hash == '#delisting_board_sz' || hash == '#delisting_board_bj') &&
                        react_1.default.createElement("div", { className: "tab3hot" },
                            react_1.default.createElement(maintab_1.MainTab3, null))),
                ['#ab_comparison', '#ab_comparison_sh', '#ab_comparison_sz'].indexOf(hash) < 0 &&
                    react_1.default.createElement("div", { className: "mzb" },
                        react_1.default.createElement(morezb_1.MoreZB, { data: custom_quote, onChange: changeSelectIndex, onIndex: onIndex }))),
        react_1.default.createElement(quotetable_1.QuoteTable, { custom_item: showzb })));
}
exports.PageHSJ = PageHSJ;
